module.exports = __webpack_public_path__ + "media/1.a9cec006.mp4";